<div class="row">
    <div [ngClass]="isEdit || isAdd ? 'col-sm-6' : 'col-sm-11'">
        <kendo-grid [data]="view"
                    [pageSize]="state.take"
                    [skip]="state.skip"
                    [sort]="state.sort"
                    [filter]="state.filter"
                    [sortable]="true"
                    [pageable]="true"
                    [filterable]="true"
                    (dataStateChange)="contactStateChange($event)">
            <!--<ng-template kendoGridToolbarTemplate>
        <button kendoGridAddCommand>Add New Contact</button>
    </ng-template>-->
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-success m-1" title="Edit" tabindex="-1" (click)="edit(dataItem)"><i class="fas fa-pencil-alt"></i></button>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-span-column>
                <kendo-grid-column field="fullName" title="Name"></kendo-grid-column>

                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.firstName}} {{dataItem.lastName}} - {{dataItem.title}}
                </ng-template>

                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                    <label>First: </label><input type="text" [(ngModel)]="dataItem.firstName" />
                    <label>Last: </label><input type="text" [(ngModel)]="dataItem.lastName" />
                    <label>Title: </label><input type="text" [(ngModel)]="dataItem.title" />
                </ng-template>
            </kendo-grid-span-column>
            <kendo-grid-column field="phone" title="Phone #">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div *ngIf="dataItem.phoneExt == null || dataItem.phoneExt.length < 1">
                        <!--<a href="tel:{{dataItem.phone}}">{{dataItem.phone.length > 10 ? (dataItem.phone | phone:'MX') : (dataItem.phone | phone:'US')}}</a>-->
                        <!--<a href="tel:{{dataItem.phone}}">{{dataItem.phoneCountryID > 0 ? (dataItem.phone | phone:dataItem.phoneCountry.abbrev.trim()) : (dataItem.phone | phone:'US')}}</a>-->
                        <a href="tel:{{dataItem.phone}}">{{dataItem.phoneCountryID > 0 ? (dataItem.phone | phone:getCountryAbbr(dataItem.phoneCountryID)) : (dataItem.phone | phone:'US')}}</a>
                    </div>
                    <div *ngIf="dataItem.phoneExt != null && dataItem.phoneExt.length > 0">
                        <!--<a href="tel:{{dataItem.phone}},{{dataItem.phoneExt}}">{{dataItem.phone.length > 10 ? (dataItem.phone | phone:'MX') : (dataItem.phone | phone:'US')}} Ext: {{dataItem.phoneExt}}</a>-->
                        <a href="tel:{{dataItem.cell}}">
                            <!--{{dataItem.phone.phoneCountryID > 0 ? (dataItem.phone | phone:dataItem.phoneCountry.abbrev.trim()) : (dataItem.phone | phone:'US')}}-->
                            {{dataItem.phone.phoneCountryID > 0 ? (dataItem.phone | phone:getCountryAbbr(dataItem.phoneCountryID)) : (dataItem.phone | phone:'US')}}
                        </a>
                        Ext: {{dataItem.phoneExt}}
                    </div>
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                    <div class="col-sm-12">
                        <div class="col-sm-8">
                            <!--<kendo-maskedtextbox [(ngModel)]="dataItem.phone" [mask]="phoneMask" maskOnFocus="false" class="form-control input-sm" type="text"></kendo-maskedtextbox>-->
                            <input type="text" [(ngModel)]="dataItem.phone" />
                        </div>
                        <div class="col-sm-4">
                            <label style="display: inline;">Ext</label>
                            <input type="text" [(ngModel)]="dataItem.phoneExt" />
                        </div>
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="cell" title="Cell #">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <!--<a href="tel:{{dataItem.cell}}">{{dataItem.cell.length > 10 ? (dataItem.cell | phone:'MX') : (dataItem.cell | phone:'US')}}</a>-->
                    <!--<a href="tel:{{dataItem.cell}}">{{dataItem.cellCountryID > 0 ? (dataItem.cell | phone:dataItem.cellCountry.abbrev.trim()) : (dataItem.cell | phone:'US')}}</a>-->
                    <a href="tel:{{dataItem.cell}}">{{dataItem.cellCountryID > 0 ? (dataItem.cell | phone:getCountryAbbr(dataItem.cellCountryID)) : (dataItem.cell | phone:'US')}}</a>
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                    <kendo-maskedtextbox [(ngModel)]="dataItem.cell" [mask]="phoneMask" class="form-control input-sm" type="text"></kendo-maskedtextbox>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="email" title="Email">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <a href="mailto:{{dataItem.email}}">{{dataItem.email}}</a>
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                    <input [(ngModel)]="dataItem.email" type="email" />
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="defaultContactInd" title="Default">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.defaultContactInd ? 'Yes' : 'No'}}
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                    <mat-checkbox [(ngModel)]="dataItem.defaultContactInd">Default</mat-checkbox>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="isAllowedVisibiltyToCustomerPortal" title="Customer Portal Access" *ngIf="contactType.toLowerCase()=='customer'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.isAllowedVisibiltyToCustomerPortal ? 'Yes' : 'No'}}
                </ng-template>
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                    <mat-checkbox [(ngModel)]="dataItem.isAllowedVisibiltyToCustomerPortal">Customer Portal Access</mat-checkbox>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="isEmailCarrierPortalLink" title="Email Carrier Portal Link" *ngIf="contactType.toLowerCase()=='carrier'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.isEmailCarrierPortalLink ? 'Yes' : 'No'}}
                </ng-template>
            </kendo-grid-column>
            <!--<kendo-grid-command-column>
        <ng-template kendoGridCellTemplate let-isNew="isNew">
            <div>
                <button kendoGridEditCommand type="button" [primary]="true">Edit</button>
                <button kendoGridSaveCommand type="button" [primary]="true">Save</button>
                <button kendoGridRemoveCommand type="button" [primary]="false">Delete</button>
                <button kendoGridCancelCommand type="button">Cancel</button>
            </div>
        </ng-template>
    </kendo-grid-command-column>-->
        </kendo-grid>
    </div>
    <div class="col-sm-1" *ngIf="!isEdit && !isAdd">
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isEdit && !isAdd"><i class="fas fa-plus"></i></button>
    </div>
    <div class="col-sm-6" *ngIf="isAdd">
        <!-- Edit Customer Action form -->
        <contact-quick-add [tableID]="tableID" [contactType]="contactType" (onRefreshContact)="refreshContact()"></contact-quick-add>
    </div>
    <div class="col-sm-6" *ngIf="isEdit">
        <!-- Edit Customer Action form -->
        <contact-quick-edit [contactID]="contactID" (onRefreshContact)="refreshContact()"></contact-quick-edit>
    </div>
</div>
